import React from "react";

import { Box, Text } from "@chakra-ui/react";

import {
  QuestionTypeEnum,
  ReportFragment,
} from "../../../graphql/generated/definitions";
import { QuestionWithAnswers } from "../types/ReportFormTypes";

import {
  QuestionSelectorMultiplePrint,
  QuestionSelectorSinglePrint,
  QuestionTextPrint,
} from "./QuestionsPrint";

const is = (q: QuestionWithAnswers, t: QuestionTypeEnum) => q.type === t;

type QuestionDispatchPrintProps = {
  question: QuestionWithAnswers;
  sectionIndex: number;
  report: ReportFragment;
};

const QuestionDispatchPrint: React.FC<QuestionDispatchPrintProps> = ({
  question,
  sectionIndex,
  report,
}) => {
  return (
    <Box className="avoid-break" pt="16">
      <Text fontSize="lg" color="black" fontWeight="semibold">
        {`${sectionIndex}.${question.order + 1}`} - {question.label}
      </Text>
      {is(question, "QuestionText") && (
        <QuestionTextPrint report={report} question={question} />
      )}
      {is(question, "QuestionSelectorMultiple") && (
        <QuestionSelectorMultiplePrint report={report} question={question} />
      )}
      {is(question, "QuestionSelectorSingle") && (
        <QuestionSelectorSinglePrint report={report} question={question} />
      )}
      {is(question, "QuestionEvaluation") && (
        <QuestionSelectorSinglePrint report={report} question={question} />
      )}
      {is(question, "QuestionSkill") && (
        <QuestionSelectorSinglePrint report={report} question={question} />
      )}
    </Box>
  );
};

export default QuestionDispatchPrint;
